// src/features/promoteur/ChargilyPaymentPageClient.jsx

import { useAuth } from "../../context/AuthContext";
import BoutonChargily from "../promoteur/BoutonChargily";

// ======================================================
// CONFIGURATION DU PACK CLIENT
// ======================================================

const MONTANT_DZD = 137000;

// Prix mensuel uniquement indicatif
const MONTANT_MENSUEL = Math.round(MONTANT_DZD / 12);

const PLAN = {
  id: "client-annual",
  label: "Publication d'une annonce — 12 mois",
  description:
    "Publiez une annonce immobilière sur BKBO pendant 12 mois.",
  amount: MONTANT_DZD,
};

// ======================================================
// COMPOSANT PRINCIPAL
// ======================================================

export default function ChargilyPaymentPageClient() {
  const { user, isLoading } = useAuth();

  // ======================================================
  // CHARGEMENT
  // ======================================================

  if (isLoading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f7f8fa",
        }}
      >
        <div
          style={{
            width: "32px",
            height: "32px",
            border: "3px solid #e5e7eb",
            borderTop: "3px solid #078D3F",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
          }}
        />

        <style>
          {`
            @keyframes spin {
              to {
                transform: rotate(360deg);
              }
            }
          `}
        </style>
      </div>
    );
  }

  // ======================================================
  // UTILISATEUR NON CONNECTÉ
  // ======================================================

  if (!user) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f7f8fa",
          padding: "20px",
        }}
      >
        <div
          style={{
            textAlign: "center",
            padding: "40px",
            background: "#ffffff",
            borderRadius: "16px",
            width: "100%",
            maxWidth: "450px",
            boxShadow: "0 8px 25px rgba(0,0,0,0.07)",
          }}
        >
          <div
            style={{
              fontSize: "48px",
              marginBottom: "16px",
            }}
          >
            🔒
          </div>

          <p
            style={{
              color: "#dc2626",
              fontSize: "15px",
              marginBottom: "20px",
              fontWeight: "600",
            }}
          >
            Vous devez être connecté pour publier une annonce.
          </p>

          <a
            href="/login"
            style={{
              display: "inline-block",
              background: "#078D3F",
              color: "#ffffff",
              padding: "12px 28px",
              borderRadius: "10px",
              textDecoration: "none",
              fontWeight: "600",
              fontSize: "15px",
            }}
          >
            Se connecter
          </a>
        </div>
      </div>
    );
  }

  // ======================================================
  // PAGE DE PAIEMENT
  // ======================================================

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f7f8fa",
        padding: "40px 20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "650px",
          background: "#ffffff",
          borderRadius: "20px",
          padding: "35px 30px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
        }}
      >
        {/* ==================================================
            TITRE
        ================================================== */}

        <div
          style={{
            textAlign: "center",
            marginBottom: "30px",
          }}
        >
          <div
            style={{
              fontSize: "42px",
              marginBottom: "10px",
            }}
          >
            🏠
          </div>

          <h1
            style={{
              margin: "0 0 10px",
              fontSize: "26px",
              fontWeight: "700",
              color: "#111827",
            }}
          >
            Publier une annonce immobilière
          </h1>

          <p
            style={{
              margin: 0,
              fontSize: "15px",
              color: "#6b7280",
              lineHeight: "1.6",
            }}
          >
            Publiez votre annonce immobilière sur BKBO et présentez
            votre bien aux acheteurs intéressés.
          </p>
        </div>

        {/* ==================================================
            PACK
        ================================================== */}

        <div
          style={{
            border: "1px solid #e5e7eb",
            borderRadius: "16px",
            padding: "24px",
            background: "#fafafa",
            marginBottom: "20px",
          }}
        >
          <h2
            style={{
              margin: "0 0 8px",
              fontSize: "20px",
              fontWeight: "700",
              color: "#111827",
            }}
          >
            {PLAN.label}
          </h2>

          <p
            style={{
              margin: "0 0 18px",
              color: "#6b7280",
              fontSize: "14px",
              lineHeight: "1.6",
            }}
          >
            {PLAN.description}
          </p>

          {/* ==================================================
              UTILISATEUR CONNECTÉ
          ================================================== */}

          <div
            style={{
              marginBottom: "16px",
              padding: "10px 14px",
              background: "#f0faf6",
              borderRadius: "10px",
              border: "1px solid #a3d9c0",
              fontSize: "13px",
              color: "#0f6e56",
              wordBreak: "break-word",
            }}
          >
            Connecté en tant que :{" "}
            <strong>{user.email}</strong>
          </div>

          {/* ==================================================
              PRIX
          ================================================== */}

          <div
            style={{
              marginBottom: "20px",
              padding: "18px",
              background: "#ffffff",
              borderRadius: "12px",
              border: "1px solid #e5e7eb",
            }}
          >
            {/* Tarif mensuel indicatif */}

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "15px",
                marginBottom: "14px",
                padding: "10px 12px",
                background: "#f0fdf4",
                borderRadius: "8px",
                border: "1px solid #bbf7d0",
              }}
            >
              <div>
                <span
                  style={{
                    fontSize: "13px",
                    color: "#15803d",
                    fontWeight: "600",
                  }}
                >
                  Équivalent mensuel
                </span>

                <span
                  style={{
                    fontSize: "11px",
                    color: "#6b7280",
                    marginLeft: "6px",
                  }}
                >
                  (indicatif)
                </span>
              </div>

              <span
                style={{
                  fontSize: "15px",
                  fontWeight: "700",
                  color: "#15803d",
                  textAlign: "right",
                }}
              >
                {MONTANT_MENSUEL.toLocaleString("fr-DZ")} DA
                <span
                  style={{
                    fontSize: "11px",
                    fontWeight: "400",
                    color: "#6b7280",
                  }}
                >
                  {" "}
                  / mois
                </span>
              </span>
            </div>

            {/* Prix réel à payer */}

            <div
              style={{
                borderTop: "1px solid #e5e7eb",
                paddingTop: "14px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "15px",
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: "15px",
                    fontWeight: "600",
                    color: "#111827",
                  }}
                >
                  Total à payer
                </div>

                <div
                  style={{
                    fontSize: "12px",
                    color: "#6b7280",
                    marginTop: "3px",
                  }}
                >
                  Paiement unique
                </div>
              </div>

              <div
                style={{
                  textAlign: "right",
                }}
              >
                <div
                  style={{
                    fontSize: "25px",
                    fontWeight: "800",
                    color: "#078D3F",
                    whiteSpace: "nowrap",
                  }}
                >
                  {MONTANT_DZD.toLocaleString("fr-DZ")} DA
                </div>

                <div
                  style={{
                    fontSize: "12px",
                    color: "#6b7280",
                    marginTop: "3px",
                  }}
                >
                  1 annonce / 12 mois
                </div>
              </div>
            </div>
          </div>

          {/* ==================================================
              INFORMATION IMPORTANTE
          ================================================== */}

          <div
            style={{
              background: "#f0fdf4",
              border: "1px solid #bbf7d0",
              borderRadius: "12px",
              padding: "14px 16px",
              marginBottom: "20px",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: "15px",
                fontWeight: "700",
                color: "#15803d",
              }}
            >
              1 paiement = 1 annonce = 12 mois
            </div>

            <div
              style={{
                fontSize: "12px",
                color: "#166534",
                marginTop: "5px",
                lineHeight: "1.5",
              }}
            >
              Le paiement permet de publier une seule annonce immobilière.
            </div>
          </div>

          {/* ==================================================
              BOUTON DE PAIEMENT CHARGILY
          ================================================== */}

          <BoutonChargily
            amount={PLAN.amount}
            serviceName={PLAN.label}
            planId={PLAN.id}
            paymentMethod=""
            customerName={user.displayName || ""}
            customerEmail={user.email || ""}
            customerPhone={user.phoneNumber || ""}
            userId={user.uid}
            successPath="/payment-success"
            failurePath="/payment-failure"
          />
        </div>

        {/* ==================================================
            CE QUI EST INCLUS
        ================================================== */}

        <div
          style={{
            border: "1px solid #dbeafe",
            borderRadius: "14px",
            padding: "20px",
            background: "#eff6ff",
            marginBottom: "20px",
          }}
        >
          <h3
            style={{
              margin: "0 0 14px",
              fontSize: "15px",
              fontWeight: "700",
              color: "#1d4ed8",
            }}
          >
            ✅ Ce qui est inclus
          </h3>

          <ul
            style={{
              margin: 0,
              padding: "0 0 0 18px",
              fontSize: "14px",
              color: "#374151",
              lineHeight: "2",
            }}
          >
            <li>
              Publication d'
              <strong>une seule annonce immobilière</strong>
            </li>

            <li>
              Durée de publication :{" "}
              <strong>12 mois</strong>
            </li>

            <li>
              Modification de votre annonce pendant sa période de validité
            </li>

            <li>
              Suivi du statut :{" "}
              <strong>
                en attente, validée ou refusée
              </strong>
            </li>

            <li>
              Validation de l'annonce par l'administration BKBO avant
              sa mise en ligne
            </li>

            <li>
              Gestion de votre annonce depuis votre espace client
            </li>

            <li>
              À l'expiration, un nouveau paiement sera nécessaire pour
              publier de nouveau
            </li>
          </ul>
        </div>

        {/* ==================================================
            RÉCAPITULATIF
        ================================================== */}

        <div
          style={{
            border: "1px solid #bbf7d0",
            borderRadius: "14px",
            padding: "20px",
            background: "#f0fdf4",
            marginBottom: "20px",
          }}
        >
          <h3
            style={{
              margin: "0 0 14px",
              fontSize: "15px",
              fontWeight: "700",
              color: "#15803d",
            }}
          >
            🏠 Votre publication BKBO
          </h3>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              fontSize: "14px",
              color: "#374151",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "15px",
              }}
            >
              <span>Nombre d'annonces</span>
              <strong>1</strong>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "15px",
              }}
            >
              <span>Durée</span>
              <strong>12 mois</strong>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "15px",
              }}
            >
              <span>Paiement</span>
              <strong>Unique</strong>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "15px",
                paddingTop: "10px",
                marginTop: "2px",
                borderTop: "1px solid #bbf7d0",
              }}
            >
              <span
                style={{
                  fontWeight: "700",
                }}
              >
                Prix
              </span>

              <strong
                style={{
                  color: "#078D3F",
                  fontSize: "17px",
                }}
              >
                {MONTANT_DZD.toLocaleString("fr-DZ")} DA
              </strong>
            </div>
          </div>
        </div>

        {/* ==================================================
            CONDITIONS
        ================================================== */}

        <div
          style={{
            border: "1px solid #fde68a",
            borderRadius: "14px",
            padding: "20px",
            background: "#fffbeb",
          }}
        >
          <h3
            style={{
              margin: "0 0 14px",
              fontSize: "15px",
              fontWeight: "700",
              color: "#92400e",
            }}
          >
            ⚠️ Conditions de publication
          </h3>

          <ul
            style={{
              margin: 0,
              padding: "0 0 0 18px",
              fontSize: "14px",
              color: "#374151",
              lineHeight: "2",
            }}
          >
            <li>
              Le paiement concerne{" "}
              <strong>une seule annonce</strong>.
            </li>

            <li>
              Chaque nouvelle annonce nécessite un nouveau paiement.
            </li>

            <li>
              Le paiement est{" "}
              <strong>non remboursable</strong> après validation.
            </li>

            <li>
              L'annonce doit être validée par l'administration BKBO
              avant sa publication.
            </li>

            <li>
              En cas de refus de l'annonce pour non-respect des
              conditions de publication, l'administration pourra
              demander sa modification.
            </li>

            <li>
              À l'expiration de la période de 12 mois, l'annonce sera
              désactivée.
            </li>

            <li>
              Une nouvelle période de publication nécessitera un
              nouveau paiement.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}